import axios from 'axios';
const config = require('../../config');

export function switchModuleSuccess(id) {
    return {
        type: 'SWITCH_MODULE_SUCCESS',
        active_module: id
    }
}

export function fetchDisplaySuccess(screen) {
    return {
        type: 'FETCH_DISPLAY_SUCCESS',
        screen: screen
    }
}

export function setOptionsSuccess(data) {
    return {
        type: 'SET_OPTIONS_SUCCESS',
        options: {
            ...data
        }
    }
}

export function fetchDisplay(data) {
    let screen = {
        sv: {}
    }
    if (data.mode === "preview") {
        screen.dpath = '/preview/'
        screen.mode = 'preview'
    }
    else if (data.mode === "web") {
        screen.dpath = "/"
        screen.mode = "web"
    } else if (data.mode === "module") {
        screen.dpath = '/preview/'
        screen.mode = 'preview'
    }
    else {
        screen.dpath = '/'
        screen.mode = "local"
    }

    if (data.webkey) {
        screen.webkey = data.webkey;
    }
    else {
        data.webkey = null
    }

    screen.entry_point = "/"
    if (data.entry_point) {
        screen.entry_point = data.entry_point
    }

    let w_h = "1x1";
    let orientation = "h";

    if (data.blocks && data.blocks[0]){
        w_h = String(data.blocks[0].width) + "x" + String(data.blocks[0].height);
        orientation = data.blocks[0].screens[0].orientation
    }

    switch (orientation) {
        case 'v':
            switch (w_h) {
                case "2x1":
                    screen.sv.height = data.screenWidth * 0.8888;
                    screen.sv.width = data.screenWidth;
                    screen.sv.top = Math.max((data.screenHeight / 2) - (data.screenWidth * 0.4444), 0);
                    screen.sv.p10 = data.screenWidth * 0.1;
                    break;
                case "1x1":
                    screen.sv.height = data.screenHeight;
                    screen.sv.width = data.screenHeight * 1.778;
                    screen.sv.left = (data.screenWidth / 2) - (data.screenHeight * 0.8888);
                    screen.sv.p10 = data.screenHeight * 0.1;
                    break;
                default:
                    break;
            }
            break;
        case 'h':
        default:
            //console.log("in the horizontal: ", w_h)
            switch (w_h) {
                case "3x1":
                    screen.sv.height = data.screenHeight;
                    screen.sv.width = data.screenHeight * 5.333333;
                    screen.sv.left = 0;
                    screen.sv.p10 = data.screenHeight * 0.1;
                    break;
                case "2x1":
                    screen.sv.height = data.screenHeight;
                    screen.sv.width = data.screenWidth;
                    screen.sv.left = (data.screenWidth / 2) - (data.screenHeight * 0.8888 * 2);
                    screen.sv.p10 = data.screenHeight * 0.1;
                    break;
                case "1x1":
                    screen.sv.height = data.screenHeight;
                    screen.sv.width = data.screenHeight * 1.778;
                    screen.sv.left = (data.screenWidth / 2) - (data.screenHeight * 0.8888);
                    screen.sv.p10 = data.screenHeight * 0.1;
                    break;
                case "1x2":
                    screen.sv.height = data.screenHeight;
                    screen.sv.width = data.screenWidth;
                    screen.sv.left = 0;
                    screen.sv.p10 = data.screenHeight * 0.1;
                    break;
                default:
                    break;
            }
            break;
    }
    
    screen.orientation = "horizontal"
    if (data.screenWidth < data.screenHeight) {
        screen.orientation = "vertical"
    }
    screen.screenWidth = data.screenWidth;
    screen.screenHeight = data.screenHeight;
    let stamp = new Date();
    screen.timeStamp = stamp.getTime() / 1000;

    //TODO: move to screen.sv values
    screen.r16_9 = {
        width: data.screenHeight * 1.778,
        half: data.screenHeight * 0.8888,
        left: (data.screenWidth / 2) - (data.screenHeight * 0.8888),
        p10: data.screenHeight * 0.1,
        h10: (data.screenHeight * 1.778) * 0.1,
    }

    screen.r9_16 = {
        height: data.screenWidth * 1.778,
        half: data.screenWidth * 0.8888,
        top: (data.screenHeight / 2) - (data.screenWidth * 0.8888),
        p10: data.screenWidth * 0.1,

    }
    //console.log("screen: ", screen);
    return (dispatch) => {
        dispatch(fetchDisplaySuccess(screen))
    };
}

export function switchModule(id) {
    return (dispatch) => {
        dispatch(switchModuleSuccess(id))
    };
}

export function setOptions(data) {
    return (dispatch) => {
        dispatch(setOptionsSuccess(data))
    };
}

export function logSuccess() {
    return {
        type: 'LOG_SUCCESS'
    }
}

export function logToServer(logs, type, display, mode, webkey) {
    return (dispatch) => {
        if (mode === "local") {
            axios.post(config.WEB_SERVER + "/display/displayLog", {
                authkey: config.AUTHKEY,
                logs: logs,
                display: Number(display),
                type: type
            }).then(() => {
                dispatch(logSuccess());
            });
        }

        if (mode === "preview") {
            axios.post(config.WEB_SERVER + "/display/webkeyLog", {
                webkey: webkey,
                logs: logs,
                display: Number(display),
                type: type
            }).then(() => {
                dispatch(logSuccess());
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/display.js